import { useTranslation } from "react-i18next";

export default function KickedScreen() {
    const { t } = useTranslation();

    return (
        <div className="flex h-screen flex-col items-center justify-center gap-3 p-6 text-center">
            <span className="text-5xl" aria-hidden>🚪</span>
            <h1 className="text-xl font-semibold text-gray-800">
                {t("constellation.kicked.title")}
            </h1>
            <p className="max-w-sm text-sm text-gray-500">
                {t("constellation.kicked.message")}
            </p>
        </div>
    );
}
